import ItemList from './ItemList';

import classes from './List.module.css';

const List = ({ data = [], columns, titleName, listTitle }) => {
  return (
    <div
      style={{
        marginTop: '1rem',
        border: '1px solid gray',
        padding: '0.5rem',
        borderRadius: '5px',
        height: '300px',
      }}
    >
      <strong>{listTitle}</strong>
      <div style={{ height: '260px', overflowY: 'auto', width: '550px' }}>
        <section className={classes.meetingListWrapper}>
          <ol className={classes.meetingList}>
            {data.length > 0 ? (
              data.map((item, index) => (
                <ItemList
                  key={index}
                  item={item}
                  columns={columns}
                  titleName={titleName}
                />
              ))
            ) : (
              <p style={{ fontSize: '16px' }}>Nema podataka.</p>
            )}
          </ol>
        </section>
      </div>
      <div className={classes.ukupnoContainer}>
        <label>Ukupno: </label>
        <label>{data.length > 0 ? data[0].ukupno : ''}</label>
      </div>
    </div>
  );
};

export default List;
